import { Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import React, {useEffect}from "react";
import BookingSuccess from "../../components/BookingSuccess";

const SiteLayout = styled(Grid)(({ theme }) => ({
  background: `url('/assets/Skiing-Image-QQF.jpg')`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  padding: '0 16px',
  [theme.breakpoints.up("sm")]: {
    padding: '0 32px',
  },
  [theme.breakpoints.up("md")]: {
    padding: '0 64px',
  },
  [theme.breakpoints.up("lg")]: {
    padding: '0 100px',
  },
}));


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // for a smooth scroll
  });
};



const SiteLayoutContent = styled(Box)(({ theme }) => ({
  padding: "24px",
  margin: "16px 0",
  minHeight: "222px",
  background: "#fff",
  borderRadius: "10px",
  display: "block",
  maxWidth: "1500px"
}));

export default function BookingSuccessfull() {
  useEffect(() => {
    // This will scroll the page to the top every time this component is mounted
    scrollToTop();
  }, []);
  return (
    <SiteLayout container>
     
      <Grid item xs={12} display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <SiteLayoutContent>
          <BookingSuccess />
        </SiteLayoutContent>
      </Grid>
    </SiteLayout>
  );
}
